export const EDIT_TYPE = {
  CREATE: 'create',
  UPDATE: 'update',
  DETAIL: 'detail',
}

export const FIELD_TYPE_EDIT = [
  'text',
  'int',
  'boolean',
  'date',
  'geometry',
  'file',
  'double',
  'array',
]
